import store from "../../store";
import { setLoading } from "../../store/slices/commonSlice";
import {
  setAttributeLov,
  setProductAttributesData,
  setProductName,
  setProductOem,
  setProductTabs,
} from "../../store/slices/product/productSlice";
import api from "../../utils/interface";

export const getProductAttributes = async (productId) => {
  store.dispatch(setLoading(true));
  const fd = new FormData();
  fd.append("productId", productId);

  try {
    api.post(`/product/getProductFilterMeta`, fd).then((response) => {
      if (response.status === 200 && response) {
        const data = response.data;

        store.dispatch(setProductAttributesData(data));

        const parentPspOem = data.pspOem || [];
        const childPspOem =
          data.child_product_list?.flatMap((child) => child.pspOem || []) || [];

        const combinedPspOem = [...parentPspOem, ...childPspOem];

        store.dispatch(setProductOem(combinedPspOem));
        store.dispatch(setProductName(response.data.name));
        store.dispatch(setLoading(false));

        if (data?.child_product_list?.length > 0) {
          const tabLabels = data.child_product_list.map(
            (product) => product.name
          );
          store.dispatch(setProductTabs(tabLabels));
        }
        return data;
      }
    });
  } catch (error) {
    console.error("Error fetching data", error);
    store.dispatch(setLoading(false));
  }
};

export const getAllAccessibleOemForProduct = async (productId, entityType) => {
  const fd = new FormData();
  fd.append("productId", productId);
  fd.append("entityType", entityType);

  try {
    api.post(`/product/getAllAccessibleDataForProduct`, fd).then((response) => {
      if (response.status === 200 && response) {
        store.dispatch(setProductOem(response.data));
      }
    });
  } catch (error) {
    console.error("Error fetching data", error);
  }
};

export const getDependentAttributeValues = async (
  entityid,
  attributeKey,
  value
) => {
  try {
    const response = await api.post(
      `/product/getDependentAttributeValues?productId=${entityid}`,
      { [attributeKey]: value },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (response.status === 200 && response) {
      store.dispatch(setAttributeLov(response.data));
      return response.data;
    }
  } catch (error) {
    console.log("error", error);
  }
};
